/**
 * A firm without a timezone takes the browser timezone of the first admin who
 * opens the app. Members who aren't admins get a 403 and nothing changes;
 * either way it is tried once per browser session.
 */
import { useEffect } from "react";

import { LawFirmsAPI } from "@/api/lawFirms";

import { browserTimezone } from "../firmTimezone";

const triedKey = (lawFirmId: string) => `firm-timezone-seeded:${lawFirmId}`;

export const seedFirmTimezone = async (lawFirmId: string): Promise<void> => {
  const zone = browserTimezone();
  if (!zone) return;
  try {
    if (window.sessionStorage.getItem(triedKey(lawFirmId))) return;
    window.sessionStorage.setItem(triedKey(lawFirmId), "1");
  } catch {
    // No storage: still try once for this mount.
  }
  try {
    const firm = await LawFirmsAPI.getById(lawFirmId);
    if (firm.timezone) return;
    await LawFirmsAPI.update(lawFirmId, { timezone: zone });
  } catch {
    // Not an admin, or offline: the default stands until someone sets it.
  }
};

export const useSeedFirmTimezone = (lawFirmId: string | null | undefined) => {
  useEffect(() => {
    if (lawFirmId) void seedFirmTimezone(lawFirmId);
  }, [lawFirmId]);
};
